module.exports = __webpack_public_path__ + "img/glazing_triple.3af13b4.svg";